if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelectorAll('[data-product-media-modal-previous], [data-product-media-modal-next]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.switchMedia(button.hasAttribute('data-product-media-modal-previous') ? 'previous' : 'next');
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.switchMedia('previous');
          }
          if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.switchMedia('next');
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.activeMediaId = opener.getAttribute('data-media-id');
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.activeMediaId || this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      switchMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (mediaItems.length < 2) return;

        const currentMedia = this.querySelector('.product-media-modal__content > .active') || mediaItems[0];
        const currentIndex = mediaItems.indexOf(currentMedia);
        const nextIndex =
          direction === 'previous'
            ? (currentIndex - 1 + mediaItems.length) % mediaItems.length
            : (currentIndex + 1) % mediaItems.length;
        const nextMedia = mediaItems[nextIndex];

        if (!nextMedia) return;

        this.activeMediaId = nextMedia.getAttribute('data-media-id');
        this.showActiveMedia();
      }
    }
  );
}
